import React from 'react';
import PropTypes from 'prop-types';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';

export const SR_TOOLTIP_V2_DIRECTION_RIGHT = 'right';
export const SR_TOOLTIP_V2_DIRECTION_LEFT = 'left';

const SR_TOOLTIP_V2_DIRECTIONS = [
  SR_TOOLTIP_V2_DIRECTION_RIGHT,
  SR_TOOLTIP_V2_DIRECTION_LEFT,
];

const SrTooltipV2 = ({
  color,
  text,
  direction,
}) => (
  <>
    <SrBox
      backgroundColor={color}
      display='inlineBlock'
      borderRadius='14px'
      padding='11px 13px'
    >
      <SrText
        color='white'
        font='greycliff'
        size='16'
        weight='800'
        lineHeight='26px'
        display='block'
      >
        {text}
      </SrText>
      <img
        alt='tooltip-arrow'
        src='/images/tooltip-triangle-blue.svg'
        style={{
          margin: direction === SR_TOOLTIP_V2_DIRECTION_RIGHT ? '5px 20px -24px auto' : '5px auto -24px 20px',
          display: 'block',
          width: '25px',
          height: '18px',
        }}
      />
    </SrBox>
  </>
);

SrTooltipV2.propTypes = {
  color: PropTypes.string,
  text: PropTypes.string.isRequired,
  direction: PropTypes.oneOf(SR_TOOLTIP_V2_DIRECTIONS),
};

SrTooltipV2.defaultProps = {
  color: '#007AFF',
  direction: SR_TOOLTIP_V2_DIRECTION_LEFT,
};

SrTooltipV2.displayName = 'SrTooltipV2';

export default SrTooltipV2;
